import React from 'react';
import { PhoneIcon, MailIcon, MapPinIcon, ClockIcon } from 'lucide-react';
export const MinimalFooter = () => {
  const currentYear = new Date().getFullYear();
  return <footer className="bg-[#333332] text-gray-100 py-8" data-id="element-333">
      <div className="max-w-[900px] mx-auto px-4" data-id="element-334">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-335">
          <div data-id="element-336">
            <h3 className="text-lg font-semibold text-white mb-4 flex items-center" data-id="element-337">
              <MapPinIcon size={18} className="mr-2 text-[#FCCA86]" data-id="element-338" />
              Contact Informatie
            </h3>
            <address className="not-italic text-sm space-y-2" data-id="element-339">
              <p data-id="element-340">BTB Bouwbedrijf</p>
              <p data-id="element-341">Paulscholtenstraat 11</p>
              <p data-id="element-342">1063ND Amsterdam</p>
              <div className="flex items-center mt-4" data-id="element-343">
                <PhoneIcon size={16} className="mr-2 text-[#FCCA86]" data-id="element-344" />
                <a href="tel:+31625387128" className="hover:text-[#FCCA86] transition-colors" data-id="element-345">
                  +31 6 253 871 28
                </a>
              </div>
              <div className="flex items-center" data-id="element-346">
                <MailIcon size={16} className="mr-2 text-[#FCCA86]" data-id="element-347" />
                <a href="mailto:info@btbbouwbedrijf.nl" className="hover:text-[#FCCA86] transition-colors" data-id="element-348">
                  info@btbbouwbedrijf.nl
                </a>
              </div>
            </address>
          </div>
          <div data-id="element-349">
            <h3 className="text-lg font-semibold text-white mb-4 flex items-center" data-id="element-350">
              <ClockIcon size={18} className="mr-2 text-[#FCCA86]" data-id="element-351" />
              Openingstijden
            </h3>
            <ul className="text-sm space-y-1" data-id="element-352">
              <li className="flex justify-between" data-id="element-353">
                <span data-id="element-354">Maandag:</span>
                <span data-id="element-355">10.00 – 18.00</span>
              </li>
              <li className="flex justify-between" data-id="element-356">
                <span data-id="element-357">Dinsdag t/m Vrijdag:</span>
                <span data-id="element-358">08.00 – 18.00</span>
              </li>
              <li className="flex justify-between" data-id="element-359">
                <span data-id="element-360">Zaterdag & Zondag:</span>
                <span data-id="element-361">Gesloten</span>
              </li>
            </ul>
          </div>
        </div>
        <div className="border-t border-gray-700 mt-8 pt-5 text-sm text-center text-gray-400" data-id="element-362">
          <p data-id="element-363">
            &copy; {currentYear} BTB Bouwbedrijf. Alle rechten voorbehouden.
          </p>
        </div>
      </div>
    </footer>;
};